"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    statBox: {
      background: '#FFFFFF',
      border: '1px solid #E2E2E2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'space-between',
      minWidth: '600px'
    },
    statBoxItem: {
      borderRight: '1px solid #E2E2E2',
      textAlign: 'left',
      padding: '20px',
      marginLeft: 0,
      marginRight: 0,
      width: '100%',
      '&:last-child': {
        borderRight: '0px solid #E2E2E2'
      }
    },
    statBoxItemName: {
      color: '#121315',
      fontSize: '16px'
    },
    statBoxTitle: {
      color: '#8D8D94',
      marginBottom: '8px'
    }
  };
}, {
  name: 'StyledStatSummary'
});
exports.useStyles = useStyles;